var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "error-icon"
  }, [_c('svg', {
    attrs: {
      "width": "10",
      "height": "10",
      "viewBox": "0 0 10 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 9L9 1",
      "stroke": "#DB1616",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 1L9 9",
      "stroke": "#DB1616",
      "stroke-width": "2"
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }